import { DEFAULTS } from "./defaults";
import { LINE_SPACING_TYPE } from "./types";
const pluginLineSpacing = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: LINE_SPACING_TYPE
  };
};
export {
  pluginLineSpacing
};
//# sourceMappingURL=viewer.js.map
